import React, { useState, useEffect } from 'react';

import { confirm } from 'react-confirm-box';
import 'bootstrap/dist/css/bootstrap.min.css';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import Image from 'react-bootstrap/Image';
import Card from 'react-bootstrap/Card';
import toast, { Toaster } from 'react-hot-toast';
import { useHistory } from 'react-router-dom';

import { NODE_APP_BASE_URL,  } from '../constants/index';
import { mondayContextProcess } from 'services/MondayService';

const Home = () => {
  // eslint-disable-next-line no-unused-vars
  const [selectedOption, setSelectedOption] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [load, setLoadmain] = useState(false);
  const [account, setAccount] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [Existaccount, setExistaccount] = useState([]);
  const [boardId, setBoardId] = useState(null);
  const [accountId, setAccountId] = useState(null);
  const [userId,setUserId]=useState(null);
  const history = useHistory();

  const options = [
    { value: 'option1', label: 'Option 1', info: 'Info for Option 1' },
    { value: 'option2', label: 'Option 2', info: 'Info for Option 2' },
    { value: 'option3', label: 'Option 3', info: 'Info for Option 3' },
  ];

 useEffect(() => {
  console.log('use effect called');

  const fetchData = async () => {
    try {
      const getMondayContext = await mondayContextProcess();
      console.log('getMondayContext ', getMondayContext);

      const boardId = getMondayContext.boardId;
      const setAccountIds = getMondayContext.account.id;
      const userIds = getMondayContext.user.id;
      console.log('boardId ', boardId);
      console.log('setAccountIds ', setAccountIds);
      console.log('userIds ', userIds);


      setBoardId(boardId);
      setAccountId(setAccountIds);
      setUserId(userIds);

      setLoadmain(true);
      const res = await fetch(`${NODE_APP_BASE_URL}/getAccountInfo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          accountId: String(setAccountIds),
          boardId: String(boardId)
        }),
      });

      const json = await res.json();
      console.log('account info ', json);
      setAccount(json);
      if (json.length > 0) {
      const firstValue = json[0]?.user_config?.find(
        item => item.fields_key === 'base_url'
      );

      if (firstValue) {
        setSelectedOption(firstValue.fields_val);
      }
    }

    } catch (error) {
      console.error('Error in useEffect ', error);
      toast.error('Something went wrong');
    } finally {
      setLoadmain(false);
    }
  };

  fetchData(); // ✅ correct place (outside function)

}, []);

  // function getQueryVariable(variable) {

  //   var query = window.location.search.substring(1);
  //   //console.log(query)//"app=article&act=news_content&aid=160990"
  //   var vars = query.split('&');
  //   //  console.log(vars) //[ 'app=article', 'act=news_content', 'aid=160990' ]
  //   for (var i = 0; i < vars.length; i++) {
  //     var pair = vars[i].split('=');
  //     //console.log(pair)//[ 'app', 'article' ][ 'act', 'news_content' ][ 'aid', '160990' ] 
  //     if (pair[0] == variable) { return pair[1]; }
  //   }
  //   return (false);
  // }

  const handleSelectChange = (e) => {
    const selectedValue = e.target.value;
    const selectedOption = options.find(option => option.value === selectedValue);
    setSelectedOption(selectedOption);
  };

  const newAccountNavigate = () => {
    let url = `/createConfirm?userId=${userId}&accountId=${accountId}&boardId=${boardId}&recipeId=${account[0]?.recipeId}&accountData=${encodeURIComponent(JSON.stringify(account))}`;
    // window.location = url;
    history.push(url);
  };

  const handleToggle = () => {
    setIsChecked(!isChecked);
  };

  // const handleSelectAccount = async () => {
  //   let id = account[0]?.user_config[0]?.fields_val;
  //   if (id === undefined || id === '' || id === null ||selectedOption===null) {
  //     toast.error('No Account Selected');
  //   }
  //   else {
  //     const ChkExist = async () => {
  //       setLoadmain(true);
  //       const res = await fetch(
  //         `${NODE_APP_BASE_URL}/checkAccountExist`, {
  //         method: 'POST',
  //         headers: {
  //           'Content-Type': 'application/json',
  //         },
  //         body: JSON.stringify({
  //           // userId: getQueryVariable('userId'),
  //           accountId: String(accountId),
  //           boardId: String(boardId),
  //           snowId: id
  //         }),
  //       }
  //       );
  //       const json = await res.json();
  //       //  setLoadmain(false);
  //       setExistaccount(json);
  //       if (json.length !== 0) {
  //         toast.success('Account Exist');

  //         // window.location = getQueryVariable('backToUrl');
  //       } else {

  //         //need to create new account || account copy from existing account 
  //         //need board id for copy
  //         // const resData = await fetch(
  //         //   'http://localhost/getAccountInfoForcheckAccountExist',{
  //         //   method: 'POST',
  //         //   headers: {
  //         //     'Content-Type': 'application/json',
  //         //   },
  //         //   body: JSON.stringify({
  //         //     userId: getQueryVariable('userId'), 
  //         //     accountId: getQueryVariable('accountId'),
  //         //     boardId:getQueryVariable('boardId'),
  //         //     snow_base_url:id
  //         //   }),
  //         // }
  //         // );
  //         // const jsonData = await resData.json();
  //         // setLoadmain(false);

  //         toast.error('Redirecting for new configurations');
  //         // let BoardIdForConfig = jsonData[0].boardId
  //         let BoardIdForConfig = 0;

  //         // let url = '/exist_account_field_selection' + '?' + 'backToUrl=' + getQueryVariable('backToUrl') + '&userId=' + getQueryVariable('userId') + '&accountId=' + getQueryVariable('accountId') + '&boardId=' + getQueryVariable('boardId') + '&snowId=' + id + '&BoardIdForConfig=' + BoardIdForConfig;
  //         // window.location = url;
  //       }

  //     };
  //     ChkExist();
  //   }


  // };

  const deleteAccount = async () => {
    try{

    const result = await confirm('Are you sure?');
    if (result == false) {
      return;
    }
    let id = account[0]?.user_config[0]?.fields_val;
    if (id == undefined || id == '' || id == null || selectedOption===null) {
      toast.error('No Account Selected');
    }
    else {
      setLoadmain(true);
      const res = await fetch(
        `${NODE_APP_BASE_URL}/DeleteAccount`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          // userId: getQueryVariable('userId'),
          accountId: String(accountId),
          boardId: String(boardId),
          snowId: id
        }),
      }
      );

      if (res.status == 200) {
        toast.success('Deleted Successfully !');
        const json = await res.json();

        setLoadmain(false);
        console.log('json', isChecked);
        setAccount(json);
        setIsChecked(!isChecked);
      } else {
        toast.error('Some Thing Went Wrong !');
      }


    }
  }catch(error){
    console.error('Error while deleting the account ',error);
    toast.error('Something went wrong');
    return;
  }finally{
    setLoadmain(false); 
  }


    // json.map(accountData => {
    //   setAccount(accountData);
    // });
  };


  const iconStyle = {
    display: 'inline-block',
    fontSize: '20px', // Reduced icon size
    color: 'white',
    cursor: 'help',
  };

  const styles = {
    select: {
      borderRadius: '5px', // Further reduced border radius
      height: '25px', // Further reduced select height
      width: '80%', // Further reduced select width
      backgroundColor: '#188754',
      color: '#A5E2C6',
      border: '1px solid white',
      fontSize: '15px', // Further reduced select text size
    },
  };

  const switchStyles = {
    position: 'relative',
    display: 'inline-block',
    width: '35px', // Further reduced switch width
    height: '12px', // Further reduced switch height
    top: '2px', // Further adjusted top position
  };

  const sliderStyles = {
    position: 'absolute',
    cursor: 'pointer',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: isChecked ? '#2196f3' : '#188754',
    transition: '0.4s',
    borderRadius: '15px', // Further reduced border radius
    border: '1px solid white',
  };

  const knobStyles = {
    position: 'absolute',
    content: '',
    height: '10px', // Further reduced knob height
    width: '10px', // Further reduced knob width
    left: isChecked ? '24px' : '1px', // Further adjusted left position
    backgroundColor: 'white',
    transition: '0.4s',
    borderRadius: '100%',
  };

  const buttonStyle = {
    borderRadius: '2px', // Further reduced button border radius
    width: '40%', // Further reduced button width
    height: '15px', // Further reduced button height
    backgroundColor: 'white',
    color: '#188754',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    border: 'none',
    outline: 'none',
    marginTop: '3px', // Further reduced margin
    fontSize: '10px', // Further reduced button text size
  };

  const buttonStyleDelete = {
    borderRadius: '2px', // Further reduced button border radius
    width: '50%', // Further reduced button width
    height: '25px', // Further reduced button height
    backgroundColor: 'red',
    color: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    border: 'none',
    outline: 'none',
    marginTop: '3px', // Further reduced margin
    fontSize: '15px', // Further reduced button text size
  };

  return (
    <>
      <Container fluid>
        <Row className="justify-content-center align-items-center" style={{ height: '85vh' }}>
          <Row style={{ color: 'white' }}>
            <Col xs={12} md={6} lg={4} xl={3} style={{ marginLeft: '8%' }}>
              <h6>
                {/* <button style={{ background: 'none', border: 'none', color: 'white' }}>&#60; Back</button> */}
              </h6>
            </Col>
          </Row>
          <Col xs={12} md={4} lg={4} xl={3}>
            <Image src="/images/leftlogo.gif" alt="GIF" fluid />
          </Col>
          <Col xs={12} md={6} lg={6} xl={4} className="justify-content-center align-items-center">
            <Card style={{ backgroundColor: '#188754', color: '#A5E2C6', border: 'none' }}>
              <Card.Body>
                <h6 style={{ color: '#CDFFEF', marginBottom: '10px', fontSize: '15px' }}>Connect your ServiceNow account</h6>
                <p><a href="https://docs-appserve-ai.scrollhelp.site/ServiceNow-Connector-App/" target="_blank" rel="noopener noreferrer" style={{ color: 'white', fontSize: '15px' }}>
                  monday to ServiceNow Integration User Guide
                </a></p>
                <div style={{ marginBottom: '5px' }}>
                  <p style={{ margin: '0px', padding: '0px', fontSize: '15px' }}>Select an option:</p>
                  <select
                    style={styles.select}
                    id="selectedAccountId"
                    value={selectedOption}
                    onChange={handleSelectChange}
                  >
                    <option value="">Select...</option>

                    {account.map(accunt_data =>
                      accunt_data.user_config.map(configdata =>
                        configdata.fields_key === 'base_url' ? (
                          <option
                            key={configdata.fields_val}
                            value={configdata.fields_val}
                          >
                            {configdata.fields_val + '[' + accunt_data.boardId + ']'}
                          </option>
                        ) : null
                      )
                    )}
                  </select>
                  <span style={iconStyle} title="Select your preferred account or Create a new account.">
                    &#9432;
                  </span>
                </div>
                <div style={{ marginBottom: '15px' }}>
                  <label style={switchStyles}>
                    <input type="checkbox" checked={isChecked} onChange={handleToggle} style={{ display: 'none' }} />
                    <span style={sliderStyles}>
                      <span style={knobStyles}></span>
                    </span>
                  </label> <span style={{ fontSize: '15px' }}>Enable Delete</span> |{' '}
                  <button onClick={newAccountNavigate} style={{ margin: '0px', padding: '0px', display: 'inline', border: 'none', backgroundColor: '#188754', color: '#A5E2C6', fontSize: '15px' }}>
                    Integrate with your account
                  </button>
                </div>
                <div style={{ marginTop: '2px' }}>
                  {
                    // isChecked === false && (<div><button onClick={handleSelectAccount} style={buttonStyle}>Select Account</button></div>)
                  }
                  {
                    isChecked === true && (<div><button onClick={deleteAccount} style={buttonStyleDelete}>Delete Account</button></div>)
                  }

                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={4} xl={3} style={{ marginLeft: '8%' }}>
            <Image src="\images\serviceNowLogoNew.png" alt="GIF" height={100} width={150} fluid />
          </Col>
        </Row>
        <Toaster />
      </Container>
    </>
  );
};

export default Home;
